'use client';
import React from 'react';
import ReactDOM from 'react-dom';

const DEFAULT_MOUNT_ID = 'app-modal-element';

export interface PortalProps {
  children?: React.ReactNode;
  mountId?: string;
}

export const Portal: React.FC<PortalProps> = ({ children, mountId = DEFAULT_MOUNT_ID }) => {
  const [mountNode, setMountNode] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    const ownerDocument = document;
    const preferredMount = mountId ? ownerDocument.getElementById(mountId) : null;
    const parent = preferredMount ?? ownerDocument.body;
    const element = ownerDocument.createElement('div');
    parent.appendChild(element);
    setMountNode(element);

    return () => {
      element.remove();
      setMountNode(null);
    };
  }, [mountId]);

  if (!mountNode) {
    return null;
  }

  return ReactDOM.createPortal(children, mountNode);
};

export default Portal;
